// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PG9t","colMin":"styles_colMin__2D_ss"};